//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      selections: [], // 列表选中列
      dmodels: [],
      editDialogVisible: false, // 新增编辑界面是否显示
      filters: {
        keyword: ''
      },
      dataForm: {
        Id: null,
        ptype: '广播电视BCS',
        dtype: '显示器',
        dclassify: '',
        dmodel: '',
        dsmodel: '',
        disabled: false,
        wlimit: 1,
        description: '',
        exwlimit: 0
      },
      dataFormRules: {
        ptype: [{ required: true, message: '请输入产品类别', trigger: 'blur' }],
        dtype: [{ required: true, message: '请输入设备种类', trigger: 'blur' }],
        dclassify: [
          { required: true, message: '请输入设备分类', trigger: 'blur' }
        ],
        dmodel: [{ required: true, message: '请输入型号', trigger: 'blur' }],
        wlimit: [
          { required: true, message: '请输入保修年限', trigger: 'change' }
        ],

        exwlimit: [
          { required: true, message: '请输入延保年限', trigger: 'change' }
        ]
      },
      ptypes: [],
      dtypes: [],
      dclassifys: []
    }
  },
  methods: {
    getlist: function() {
      let params = {
        Keyword: this.filters.keyword.trim(),
        PType: '广播电视BCS',
        DType: '显示器'
      }
      this.$api
        .getDModel(params)
        .then(res => {
          if (res.Status === 1) {
            this.dmodels = res.Entity
            this.pclassifySelectChanged()
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
        .catch(function(res) {
          alert(res)
        })
    },
    getPType: function() {
      let params = {}
      this.$api
        .getPType(params)
        .then(res => {
          if (res.Status === 1) {
            this.ptypes = res.Entity
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
        .catch(function(res) {
          alert(res)
        })
    },
    ptypeSelectChanged: function(selVal) {
      let params = { PType: this.dataForm.ptype }
      this.$api
        .getDType(params)
        .then(res => {
          if (res.Status === 1) {
            this.dtypes = res.Entity
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
        .catch(function(res) {
          alert(res)
        })
    },
    pclassifySelectChanged: function(selVal) {
      let params = { DType: this.dataForm.dtype }
      this.$api
        .getDClassify(params)
        .then(res => {
          if (res.Status === 1) {
            this.dclassifys = res.Entity
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
        .catch(function(res) {
          alert(res)
        })
    },
    handleAdd: function() {
      this.dataForm = {
        Id: null,
        ptype: '广播电视BCS',
        dtype: '显示器',
        dclassify: '',
        dmodel: '',
        dsmodel: '',
        disabled: false,
        wlimit: 1,
        description: '',
        exwlimit: 0
      }
      this.ptypes = []
      this.getPType()
      this.editDialogVisible = true
    },
    handleRemove: function() {
      this.$confirm(
        '删除' + this.selections.length.toString() + '个型号吗？',
        '提示',
        { cancelButtonClass: 'btn-custom-cancel' }
      ).then(() => {
        let ids = []
        this.selections.forEach(pt => {
          ids.push(pt.Id)
        })
        this.$api.deleteDModel(ids).then(res => {
          if (res.Status === 1) {
            this.$message({ message: '删除成功', type: 'success' })
            this.getlist()
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
      })
    },
    handleEdit: function(pt) {
      this.dataForm = {
        Id: pt.Id,
        ptype: pt.PType,
        dtype: pt.DType,
        dclassify: pt.DClassify,
        dmodel: pt.DModel,
        dsmodel: pt.DSModel,
        disabled: !pt.Enabled,
        wlimit: pt.WLimit,
        description: pt.Description,
        exwlimit: pt.EXWLimit
      }
      this.ptypes = []
      this.getPType()
      this.editDialogVisible = true
    },
    editSubmit: function() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          var am = '保存'
          if (this.dataForm.Id === null) am = '新建'

          let params = {
            Id: this.dataForm.Id,
            PType: this.dataForm.ptype,
            DType: this.dataForm.dtype,
            DClassify: this.dataForm.dclassify,
            DModel: this.dataForm.dmodel,
            DSModel: this.dataForm.dsmodel,
            WLimit: this.dataForm.wlimit,
            Description: this.dataForm.description,
            EXWLimit: this.dataForm.exwlimit,
            Enabled: !this.dataForm.disabled
          }
          this.$api.saveDModel(params).then(res => {
            if (res.Status === 1) {
              this.$message({ message: am + '成功', type: 'success' })
              this.editDialogVisible = false
              this.getlist()
            } else {
              this.$alert(res.Message, '错误', {
                confirmButtonText: '确定'
              })
            }
          })
        }
      })
    },
    visibleChange(isVisible) {
      const isEdge = window.navigator.userAgent.includes('Edge')
      if (isEdge && !isVisible) {
        document
          .querySelectorAll('body > .el-select-dropdown.el-popper')
          .forEach(it => it.remove())
      }
    },
    selectionChange: function(selections) {
      this.selections = selections
    },
    formatEnabled: function(row, column) {
      return row.Enabled === true ? '' : '是'
    }
  },
  created() {
    this.getlist()
  }
}



// WEBPACK FOOTER //
// ./src/admin/Repair/RepairDmodel.vue